import type { CapturePort } from '@Domain/Ports/Capture/CapturePort';
import PortsContext from '@UI/Providers/PortsProvider/PortsContext';
import * as React from 'react';

function useCapturePort(): CapturePort {
	const context = React.useContext(PortsContext);

	if (context === null) {
		throw new Error('useCapturePort doit être utilisé à l’intérieur d’un PortsProvider.');
	}

	return context.capture;
}

export default useCapturePort;
